import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { DecorativeDivider, OmMark, CornerOrnament } from "@/components/Ornaments";

export default function KnowledgeHub() {
  const { t } = useTranslation();
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    api.get("/content/knowledge").then(({ data }) => setArticles(data));
  }, []);

  return (
    <div data-testid="knowledge-hub-page">
      <section className="section-tight bg-paper-strong relative overflow-hidden">
        <CornerOrnament corner="tr" element="mandala" />
        <div className="container-x relative text-center">
          <OmMark size={42} className="mx-auto text-[color:var(--brand)] mb-4" />
          <DecorativeDivider label={t("nav.knowledge")} className="mb-5" />
          <h1 className="font-heading text-5xl md:text-7xl tracking-display leading-[0.98]">
            Trimbakeshwar <em className="italic-serif text-[color:var(--brand)]">Knowledge Hub</em>
          </h1>
          <p className="mt-5 max-w-2xl mx-auto opacity-80">{t("knowledge.subtitle")}</p>
        </div>
      </section>

      <section className="section bg-paper">
        <div className="container-x grid md:grid-cols-2 gap-6">
          {articles.map((a, idx) => (
            <Link
              key={a.slug}
              to={`/knowledge/${a.slug}`}
              data-testid={`knowledge-card-${a.slug}`}
              className="card-pooja rounded-md overflow-hidden group flex flex-col md:flex-row p-3"
            >
              <div className="arch-mask md:w-2/5 aspect-[5/3] md:aspect-auto relative">
                <img src={a.image_url} alt={a.title} className="w-full h-full object-cover" />
                <div className="absolute top-3 left-3 w-9 h-9 rounded-full bg-[#faf8f5]/95 flex items-center justify-center font-heading italic-serif text-[color:var(--brand)]">
                  {String(idx + 1).padStart(2, "0")}
                </div>
              </div>
              <div className="p-5 md:p-6 flex-1 flex flex-col">
                <h3 className="font-heading text-2xl md:text-[1.6rem] leading-tight tracking-display">{a.title}</h3>
                <div className="gilt-rule my-4 w-12" />
                <p className="text-[14px] opacity-80 leading-relaxed line-clamp-3 flex-1">{a.summary}</p>
                <div className="mt-5 text-sm text-[color:var(--brand)] inline-flex items-center gap-1">
                  {t("knowledge.readMore")} <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
